import React, { Component } from "react";
import {
    Typography,
    Snackbar,
    SnackbarContent,
    MenuItem,
    Select,
    Divider,
} from "@material-ui/core";
import { connect } from "react-redux";
import {
    getUserData,
    setPage,
    setRowsPerPage,
    setReportStatus,
    setSelectedRow,
    setReportEditStatus,
    setStatusChangeModal,
    deleteReport,
    setDeleteStatus,
    getTmPlans,
    getEndPoints,
    getData,
} from "./actions";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";
import { Label } from "reactstrap";

import {
    selectReportFilterState,
    selectTableData,
    selectPage,
    selectRowsPerPage,
    selectSelectedRow,
    selectDeleteStatus,
    canUpdate,
    canCreate,
    canDelete,
    getRequestedTmPlans,
    selectEndPoints,
    EndPoints,
} from "./selectors";
import "./submittedReportsStyles.css";
import TableData from "./TableData";
import ChangeStatusModal from "./ChangeStatusModal";

class RequestedTMPlans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            modalType: false,
            modalData: false,
            plan_ref: "select_client",
        };
        props.getEndPoints();
    }
    render() {
        const {
            tableData,
            page,
            rowsPerPage,
            setPage,
            setRowsPerPage,
            selectedRow,
            setSelectedRow,
            deletedStatus,
            deleteReport,
            endpoints,
            point,
        } = this.props;
        return (
            <div>
                <StyledCard>
                    <StyledHeader>
                        <Typography variant="h5">
                            Master Requested TM Plans View
                        </Typography>
                    </StyledHeader>
                    <StyledContent>
                        <Label for="client">
                            Select Client:&nbsp;&nbsp;&nbsp;
                        </Label>
                        <Select
                            id="client"
                            value={this.state.plan_ref}
                            style={{ width: "190px" }}
                            onChange={(event) => {
                                this.setState({ plan_ref: event.target.value });
                                if (event.target.value !== "all") {
                                    this.props.getUserData(event.target.value);
                                } else {
                                    this.props.getData(endpoints);
                                }
                            }}
                        >
                            <MenuItem value="select_client">Select</MenuItem>
                            {point &&
                                Object.keys(point).map((e) => {
                                    return (
                                        <MenuItem
                                            value={point[e]}
                                            key={point[e]}
                                        >
                                            {e}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                        <Divider
                            style={{ marginTop: "8px", marginBottom: "8px" }}
                        />
                        <StyledViewContainer>
                            <TableData
                                tableData={tableData}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                setPage={setPage}
                                setRowsPerPage={setRowsPerPage}
                                selectedRow={selectedRow}
                                setSelectedRow={setSelectedRow}
                                setModal={(open, type, index) => {
                                    this.setState({
                                        modalOpen: open,
                                        modalType: type,
                                        modalData: tableData[index],
                                    });
                                }}
                                canDelete={this.props.canDelete}
                                canUpdate={this.props.canUpdate}
                            />
                            <ChangeStatusModal
                                modalOpen={this.state.modalOpen}
                                modalType={this.state.modalType}
                                modalData={this.state.modalData}
                                deleteReport={deleteReport}
                                setModal={(open, type, index) => {
                                    this.setState({
                                        modalOpen: open,
                                        modalType: type,
                                        modalData: index,
                                    });
                                }}
                            />
                            <Snackbar
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                autoHideDuration={4000}
                                open={
                                    deletedStatus.deleteSuccess ||
                                    deletedStatus.deleteFail
                                }
                                onClose={() => {
                                    setDeleteStatus();
                                }}
                            >
                                <SnackbarContent
                                    style={{
                                        backgroundColor: deletedStatus.deleteSuccess
                                            ? "green"
                                            : deletedStatus.deleteFail
                                            ? "red"
                                            : "white",
                                        color: "white",
                                    }}
                                    message={
                                        deletedStatus.deleteSuccess
                                            ? "Report Successfully Deleted"
                                            : "Unable to Delete Report, Please Contact System Admin With Report Details"
                                    }
                                />
                            </Snackbar>
                        </StyledViewContainer>
                    </StyledContent>
                </StyledCard>
            </div>
        );
    }
}
export default connect(
    (store) => {
        return {
            filterState: selectReportFilterState(store),
            tableData: selectTableData(store),
            page: selectPage(store),
            rowsPerPage: selectRowsPerPage(store),
            selectedRow: selectSelectedRow(store),
            deletedStatus: selectDeleteStatus(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            tmplan: getRequestedTmPlans(store),
            endpoints: selectEndPoints(store),
            point: EndPoints(store),
        };
    },
    {
        getUserData,
        setPage,
        setRowsPerPage,
        setReportStatus,
        setSelectedRow,
        setReportEditStatus,
        setStatusChangeModal,
        deleteReport,
        setDeleteStatus,
        getTmPlans,
        getEndPoints,
        getData,
    }
)(RequestedTMPlans);
